import axios from 'axios'
import { Message, Loading } from 'element-ui'
import store from 'good-storage'
import router from '../router'
import $cookies from 'vue-cookies'

let loading // 定义loading变量

function startLoading () { // 使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.5)'
  })
}
function endLoading () { // 使用Element loading-close 方法
  loading.close()
}
// 那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
// 声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
// 调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0
export function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

// 请求拦截
axios.interceptors.request.use(
  config => {
    // 1. 这个位置就请求前最后的配置
    // 2. 当然你也可以在这个位置 加入你的后端需要的用户授权信息
    if (store.get('Authorization') && !config.url.includes('restapi')) {
      config.headers['auth-user'] = store.get('Authorization')
    }
    showFullScreenLoading()
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
axios.interceptors.response.use(
  response => {
    // 请求成功
    // 1. 根据自己项目需求定制自己的拦截
    // 2. 然后返回数据
    let responseData = response.data

    if (responseData && responseData.code === 301) {
      Message.warning({
        message: '登录过期，请重新登录'
      })
      $cookies.remove('user_session')
      // TODO：弹出登录
      router.push({
        name: 'Login',
        params: {}
      })
    }
    tryHideFullScreenLoading()
    return responseData
  },
  error => {
    // 请求失败
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          // 对400错误的处理
          Message.error({
            message: '错误请求'
          })
          break
        case 401:
          // 对401错误的处理
          /* Message.warning({
            message: '请登录'
          })
          store.remove('Authorization') */
          // router.push({
          //   name: 'Login',
          //   params: {}
          // })
          break
        case 403:
          // 对 403 错误进行处理
          Message.error({
            message: '拒绝访问'
          })
          break
        case 404:
          // 对 404 错误进行处理
          Message.error({
            message: '请求错误,未找到该资源'
          })
          break
        case 500:
          // 对 500 错误进行处理
          Message.error({
            message: '服务器端出错'
          })
          break
        case 502:
          // 对 502 错误进行处理
          Message.error({
            message: '网络错误'
          })
          break
        case 503:
          // 对 503 错误进行处理
          Message.error({
            message: '服务不可用'
          })
          break
        case 504:
          // 对 504 错误进行处理
          Message.error({
            message: '网络超时'
          })
          break
        default:
          // 如果以上都不是的处理
          Message.error({
            message: '未知错误'
          })
          break
          // return Promise.reject(error)
      }
    } else {
      Message.error({
        message: '连接到服务器失败'
      })
    }

    return Promise.reject(error)
  }
)



// WEBPACK FOOTER //
// ./src/utils/axios.js